


















import Vue from "vue";
import { authentication } from "@/stores";

export default Vue.extend({
  name: "Header",
  data() {
    return {
      versionName: "version:__VERSION__",
      logoUrl:
        location.host == "console.a-town-app.com"
          ? "/assets/images/common/logo-aeontown.svg"
          : "/assets/images/common/logo-aeontown-stg.svg",
      authentication
    };
  },
  computed: {
    userName(): string {
      return this.authentication?.user?.displayName || "";
    }
  },
  methods: {
    async signOut() {
      this.$router.push("/signOut");
    }
  }
});
